import React, { useState } from "react";
import { Form, OverlayTrigger, Tab, Tabs } from "react-bootstrap";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ProfileSettingsService from "../../../core/service/ProfileSettingsService";
import Utils from "../../../core/utilities/Utils";
import "./ProfileSettings.scss";

function ProfileSettings({ t }) {
  const [validatedPwd, setValidatedPwd] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handlePasswordReset = (e) => {
    e.preventDefault();
    if (
      newPassword &&
      confirmPassword &&
      currentPassword &&
      newPassword === confirmPassword
    ) {
      let param = {
        newPassword: newPassword,
        currentPassword: currentPassword,
      };
      ProfileSettingsService.changePassword(param)
        .then((response) => {
          if (response.status === 200) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            setCurrentPassword("");
            setNewPassword("");
            setConfirmPassword("");
          }
        })
        .catch((error) => { });
    } else if (
      newPassword &&
      confirmPassword &&
      newPassword !== confirmPassword
    ) {
      toast.error(t("NewConfirmdoesntmatch.label"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      setValidatedPwd(true);
    } else {
      setValidatedPwd(true);
    }
  };

  const handleSelect = (key) => {
  };

  return (
    <div className="ProfileSettings 1">
      <div>
        <h6>{t("UserProfile.label")}</h6>
      </div>
      <div className="row m-0">
        <div className="col-lg-12 p-2">
          <Tabs
            defaultActiveKey="password"
            id="uncontrolled-tab-example"
            className="profilesettings-tab"
            onSelect={(k) => handleSelect(k)}>
            <Tab eventKey="password" title={t("UpdatePassword.label")}>
              <div className=" card company-details-card">
                <Form noValidate validated={validatedPwd}>
                  <div className="card-body">
                    <div className="col-lg-6 p-2">
                      <label className="mb-1">{t("CurrentPassword.label")}</label>
                      <input
                        type="password"
                        className="form-control"
                        value={currentPassword}
                        required
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                    </div>
                    <div className="col-lg-6 p-2">
                      <label className="mb-1">{t("NewPassword.label")}</label>
                      <OverlayTrigger
                        placement="bottom"
                        overlay={Utils.renderTooltip(
                          <div className="OverlayList text-left">
                            <h6> {t("PasswordCriteria.label")}</h6>
                            <ul className="list-inline">
                              <li>{t("containalphabet.label")}</li>
                              <li>{t("containdigital.label")}</li>
                              <li>{t("containspecial.label")}</li>
                              <li>{t("seqencecharater.label")}</li>
                            </ul>
                          </div>
                        )}
                      >
                        <input
                          type="password"
                          className="form-control"
                          value={newPassword}
                          required
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                      </OverlayTrigger>
                    </div>
                    <div className="col-lg-6 p-2">
                      <label className="mb-1">{t("ConfirmPassword.label")}</label>
                      <input
                        type="password"
                        className="form-control"
                        value={confirmPassword}
                        required
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                    <div className="text-start p-2">
                      <button
                        type="button"
                        className="btn btn-secondary me-2 px-4"
                        onClick={() => {
                          navigate(`/company_admin/dashboard`);
                        }}
                      >
                        <label className="mb-1">{t("Cancel.label")}</label>
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary px-4 sbmBtn"
                        onClick={handlePasswordReset}
                      >
                        <label className="mb-1">{t("Save.label")}</label>
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
ProfileSettings.propTypes = {};
ProfileSettings.defaultProps = {};
export default withTranslation()(ProfileSettings);
